function addVechile() {
  $("#gv-save-vehicles").find("a.add-vehicle").click();
}
function deleteVechile(val) {
  $("#gv-save-vehicles li#" + val)
    .find("a.gv-del-vehicle")
    .click();
}
function gotoVechile(val) {
  $("#gv-save-vehicles li#" + val)
    .find("a.vehicle-link")
    .click();
}
function RenderVehiclesList(vehicles) {
  //console.log("govedia VEHICLES LIST: " + vehicles);

  var jsonVehicles;
  var deleteLabel = "Delete";
  var div = $(".gv-vehicles-custom");
  div.find("ul").html("");

  try {
    jsonVehicles = JSON.parse("[" + vehicles + "]");
  } catch (e) {
    console.log("error: " + e);
  }

  if (jsonVehicles == null) return;

  //console.log("govedia - json");
  //console.log(jsonVehicles);
  var anchAdd = $("<a/>")
    .attr("href", "javascript:void(0);")
    .addClass("toggle")
    .addClass("add-vehicle")
    .html("+ Add Current Vehicle")
    .on("click", function (e) {
      e.preventDefault();
      addVechile();
    });
  $("#gv-add-vehicle").html("").append(anchAdd);

  for (var i = 0; i < jsonVehicles.length; i++) {
    var currentVehicle = jsonVehicles[i];

    //console.log(currentVehicle);
    //Add delete link
    var anchorDel = $("<a class='gv-del-vehicle'>")
      .attr("href", "javascript:void(0);")
      .attr("json", JSON.stringify(currentVehicle))
      .attr("ref", VehicleObjectTag(currentVehicle))
      .html(deleteLabel)
      .click(function (e) {
        e.preventDefault();
        //bind custom html delete button to govedia delete button
        deleteVechile(VehicleObjectTag(currentVehicle));
      });
    //console.log(anchorDel);
    div.find("ul").append(
      $("<li/>")
        .attr("id", VehicleObjectTag(currentVehicle))
        .append(
          //add vehicle link
          $("<a/>")
            .addClass("vehicle-link")
            .attr("json", JSON.stringify(currentVehicle))
            .attr("ref", VehicleObjectTag(currentVehicle))
            .attr("href", "javascript:void(0);")
            .html(VehicleObjectForDisplay(currentVehicle))
            .click(function (e) {
              e.preventDefault();
               //bind custom html MMY link to govedia MMY link
              gotoVechile(VehicleObjectTag(currentVehicle));
            })
        )
        .append(
          '<div id="vehiclelist"><div><b>Make:</b>' +
            currentVehicle.make +
            "</div><div><b>Model:</b>" +
            currentVehicle.model +
            "</div><div><b>Year:</b>" +
            currentVehicle.year +
            "</div></div>"
        )
        .append(anchorDel)
    );
  }

  div.find("ul").attr("id", "root-vehicle-list");
  if (jsonVehicles.length > 0) {
    div.find("ul").addClass("vehicles-present");
  }

  return;
}

function VehicleObjectForDisplay(vehicleObj) {
  return vehicleObj.make + " " + vehicleObj.model + " " + vehicleObj.year;
}
function VehicleObjectTag(vehicleObj) {
  if (
    vehicleObj == null ||
    vehicleObj.make == null ||
    vehicleObj.model == null ||
    vehicleObj.year == null
  )
    return "";

  return EncodeTag(
    vehicleObj.make + " " + vehicleObj.model + " " + vehicleObj.year
  );
}

function escapeRegExp(str) {
  return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
}

function replaceGvAll(str, find, replace) {
  return str.replace(new RegExp(escapeRegExp(find), "g"), replace);
}

function EncodeTag(tag) {
  tag = replaceGvAll(tag, "-fs-", "-");
  tag = replaceGvAll(tag, " ", "-");
  tag = replaceGvAll(tag, "&", "-");
  tag = replaceGvAll(tag, ".", "-");
  tag = replaceGvAll(tag, ",", "-");
  tag = replaceGvAll(tag, "--", "-");
  tag = replaceGvAll(tag, '"', "");
  return tag;
}


//On page load render vehicle html and bind html changes for ajax updating
window.onload = function () {
  RenderVehiclesList(MMY_Vehicles);

  //only make feature available (saving vehicles) to customer's who are logged in
  if (typeof MMY_Customer === "undefined" || MMY_Customer == "") {
    $(".gv-vehicles-custom").html(
      "<div class='gv-garage-info'>Please <a href='/account/login'><u>sign-in</u></a> to use this feature.</div>"
    );
  }
  $(".gv-vehicles-custom").show();

  //Update custom html on ajax update
  $("#gv-save-vehicles").bind(
    "DOMNodeInserted DOMNodeRemoved DOMSubtreeModified",
    function () {
      var links = $(this).find("#root-vehicle-list .vehicle-link");
      var vehicles = "";
      if (links.length > 0) {
        for (var i = 0; i < links.length; i++) {
          console.log($(links[i]).attr("json"));
          vehicles = vehicles + $(links[i]).attr("json");
          if (i < links.length - 1) {
            vehicles = vehicles + ",";
          }
        }
      }
      RenderVehiclesList(vehicles);
    }
  );
};
